import React from "react";
import { Divider, makeStyles } from "@material-ui/core";
import CompositionBox from "./CompositionBox";
import clsx from "clsx";

type DynamicDividerProps = {
  maxWidth?: number;
  className?: string;
};

const useStyles = makeStyles(() => ({
  divider: () => ({
    margin: "2rem auto",
    width: "100%",
  }),
}));

const DynamicDivider: React.FC<DynamicDividerProps> = (props: DynamicDividerProps) => {
  const css = useStyles(props);

  return (
    <CompositionBox maxWidth={props.maxWidth}>
      <Divider className={clsx(css.divider, props.className)} />
    </CompositionBox>
  );
};

export default DynamicDivider;
